<p-floatLabel>
  <p-select #questionTypeDropdown
      id="questionTypeDropdown"
      name="questionTypeDropdown"
      [options]="questionTypes"
      [(ngModel)]="questionType"
      [showClear]="!isRequired"
      [checkmark]="true"
      styleClass="w-100"
      (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="questionTypeDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Type') }}
    </app-label-content>
  </label>
</p-floatLabel>
